import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import initialState from "../initial-state";

export interface BuyBonusCfg {
  [bonus: string]: {
    multiplier: number;
    stakeMap: { [stake: string]: string };
  };
}

export interface BuyBonusType {
  active: string | null;
  bonuses: BuyBonusCfg;
}

const buyBonus = createSlice({
  name: "buyBonus",
  initialState: initialState.buyBonus,
  reducers: {
    setActiveBuyBonus(state, action: PayloadAction<string | null>) {
      if (state === null) return state;

      return { ...(state as any), active: action.payload };
    },

    initBuyBonus(_, action: PayloadAction<BuyBonusCfg>) {
      return { bonuses: action.payload, active: null };
    },
  },
});

export const { setActiveBuyBonus, initBuyBonus } = buyBonus.actions;

export default buyBonus;
